import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { MessageType } from 'common/enums';

import initialAppState from './appState.state';
import { MessageModal } from 'common/models/appState.model';

const appStateSlice = createSlice({
    name: 'appState',
    initialState: initialAppState,
    reducers: {
        showMessageModal: (state, { payload }: PayloadAction<MessageModal>) => {
            state.messageModal = payload;
        },
        closeMessageModal: (state) => {
            state.messageModal = {
                isVisible: false,
                header: '',
                message: '',
                type: MessageType.Default
            };
        },
        showLoader: (state, { payload }: PayloadAction<boolean>) => {
            state.showLoader = payload;
        },
        resetToInitial: (state) => {
            delete state.messageModal;
        },
        toggleSessionRenewal: (state, { payload }: PayloadAction<boolean>) => {
            state.isSessionRenewalVisible = payload;
        }
    }
});

export default appStateSlice.reducer;
export const appStateActions = appStateSlice.actions;
